import {useEffect, useState} from "react";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import Loading from "../../../component/Loading/Loading";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {useNavigate, useParams} from "react-router-dom";
import {getDiscountCodeById} from "../../DiscountCode/functions";
import DiscountCodeForm from "../component/DiscountCodeForm/DiscountCodeForm";

const UpdateDiscountCode = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);

    const exceptionGood = {
        includeProduct: [],
        excludeProduct: [],
        includeCategory: [],
        excludeCategory: [],
        includeBrand: [],
        excludeBrand: [],
    }
    const exceptionPerson = {
        isAllCustomer: "FALSE",
        includeCustomerAreaBlock: [],
        excludeCustomerAreaBlock: [],
        includeCustomerTown: [],
        excludeCustomerTown: [],
        includeCustomerId: [],
        excludeCustomerId: [],
    }
    const [discountCode, setDiscountCode] = useState({
        code: "",
        description: "",
        minimumBillAmount: "",
        expirationTimestamp: Math.round(+new Date() / 1000),
        numberOfUse: "",
        billDiscountAmount: "",
        billDiscountPercent: "",
        maxBillDiscount: "",
        deliveryDiscountAmount: "",
        deliveryDiscountPercent: "",
        maxDeliveryDiscount: "",



        exceptionPerson: {...exceptionPerson},
        exceptionGood: {...exceptionGood},

    });


    useEffect(() => {
        (async () => {
            document.title = "ویرایش کد تخفیف"
            const discountCode = await getDiscountCodeById(id);
            setDiscountCode(discountCode)
            setIsLoading(false);
        })();

    }, []);

    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getManagerHeader();

        /*const newIncludeCustomerId = [] ;
        for (let i = 0; i < discountCode.exceptionPerson.includeCustomerId.length ; i++) {
            const customerId = discountCode.exceptionPerson.includeCustomerId[i].split("_")[0];
            if (!newIncludeCustomerId.includes(customerId))
                newIncludeCustomerId.push(customerId);
        }
        discountCode.exceptionPerson.includeCustomerId = newIncludeCustomerId;*/

        console.log(discountCode);
        axios.put(baseCmsApiUrl + 'discountCodes', discountCode, {headers})
            .then((response) => {
                console.log(response.data)
                toastSuccess(base64DecodeUnicode(response.statusText));
                navigate("/discount-codes");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">ویرایش کد تخفیف</h1>
            </div>

            <DiscountCodeForm discountCode={discountCode} onChange={(value) => {
                // console.log(value);
                setDiscountCode(value);
            }}/>

            <button className={"btn btn-secondary btn-lg w-100"} onClick={handleSubmit} disabled={isLoading}>ویرایش کد تخفیف</button>
        </div>
    )
}

export default UpdateDiscountCode;